import { useCallback } from 'react';
import { recsAPI } from '../api';

const ANON_KEY = 'lunora_anon_id';

const getAnonId = () => {
  let id = localStorage.getItem(ANON_KEY);
  if (!id) {
    id = `anon_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(ANON_KEY, id);
  }
  return id;
};

/**
 * useEventTracker — fires events to /api/recommendations/events.
 * Falls back gracefully when offline / API errors so UX is never blocked.
 */
const useEventTracker = () => {
  const track = useCallback(async (type, payload = {}) => {
    if (!type) return;
    try {
      await recsAPI.trackEvent({
        type,
        anon_id: getAnonId(),
        product_id: payload.product_id || payload.productId || '',
        category: payload.category || '',
        subcategory: payload.subcategory || '',
        metadata: payload.metadata || {},
      });
    } catch {
      // ignore
    }
  }, []);
  return track;
};

export default useEventTracker;
